import { type FC } from 'react';

import { energyConverter } from 'models';
import { FormatHelpers } from 'helpers/formatters';

import { CapacityField } from 'components/component-fields/CapacityField';
import { useComponentSearchFilters } from 'components/component-overview/hooks/use-component-search-filters';
import { InlineFilters } from 'components/component-overview/inline-filters/InlineFilters';
import { SearchService } from 'components/component-overview/services/SearchService';

const InlineFiltersCapacity: FC = () => {
    const { energyCapacity } = useComponentSearchFilters();

    const label = FormatHelpers.formatValue(energyCapacity?.value, energyConverter, energyCapacity?.unit);

    const onRemove = () => {
        SearchService.setFilter('energyCapacity', undefined);
    };

    if (!energyCapacity) return null;

    return (
        <InlineFilters.Section
            body={
                <InlineFilters.MeasurementWrapper label={label} placeholder="Capacity">
                    <CapacityField name="energyCapacity" size="xs" hideIcons />
                </InlineFilters.MeasurementWrapper>
            }
            onRemove={onRemove}
            active
        />
    );
};

export { InlineFiltersCapacity };
